import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import {
  selectToken,
  selectUsdAmount,
  selectTokenAmount,
  selectCardReceiverEmail,
  selectMessage,
} from '../../redux/slices/customizeCard';

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
`;

const Gifts = () => {
  const selectedToken = useSelector(selectToken);
  const usdAmount = useSelector(selectUsdAmount);
  const tokenAmount = useSelector(selectTokenAmount);
  const email = useSelector(selectCardReceiverEmail);
  const personalMessage = useSelector(selectMessage);

  const percentage = 2;
  const transactionFee = (usdAmount * percentage) / 100;
  const formattedFee = `${transactionFee.toFixed(2)}`;
  const totalAmount = (parseFloat(usdAmount || 0) + transactionFee).toFixed(2);

  const sharedData = {
    selectedToken,
    usdAmount,
    tokenAmount,
    email,
    personalMessage,
    transactionFee,
    formattedFee,
    totalAmount,
  };

  return (
    <>
      <Container>
        <Outlet context={sharedData} />
      </Container>
    </>
  );
};

export default Gifts;
